module.exports = __webpack_public_path__ + "entry-logged-out-48909c19/Background_01_1x1_a-20ae4d5fa6c5e440da465437787dcf56.svg";